import { DefaultState } from '@src/redux/types'

import * as TYPES from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [TYPES.STUDENT_QUIZ_BY_ID]: DefaultState<`${typeof API.STUDENT_QUIZ_BY_ID}`, 'get'>
  [TYPES.STUDENT_QUIZ_ALL]: DefaultState<`${typeof API.STUDENT_QUIZ_ALL}`, 'get'>
  [TYPES.STUDENT_QUIZ_LIST]: DefaultState<`${typeof API.STUDENT_QUIZ}`, 'get'>
  // [TYPES.STUDENT_QUIZ_SELECT]: DefaultState<`${typeof API.STUDENT_QUIZ_SELECT}`, 'get'>
} = () => ({
  [TYPES.STUDENT_QUIZ_BY_ID]: defaultState(),
  [TYPES.STUDENT_QUIZ_ALL]: defaultState(),
  [TYPES.STUDENT_QUIZ_LIST]: defaultState(),
  // [TYPES.STUDENT_QUIZ_SELECT]: defaultState(),
})
